<template>
  <div class="container py-5">

    <div class="level">
      <div class="level-left buttons flex-row mb-0">
        <div class="title is-4 mr-3 ml-1">
          Estimations
        </div>
      </div>

      <div class="level-right buttons">
        <v-fade-transition>
          <button 
            class="button mb-0"
            v-if="selected.length > 0"
            @click="launchConfirmDelete()">
            <span class="icon is-medium">
              <i class="fas fa-trash has-text-danger"></i>
            </span>
            <span>Delete {{ selected.length }} selected estimations</span>
          </button>
        </v-fade-transition>
        <search-autocomplete
          :value="filters.project_id"
          @input="filterByProject($event)"
          :product-brand="filters.product_brand">
        </search-autocomplete>
      </div>
    </div>

    <div class="tabs mb-0 mt-2">
      <ul>
        <li 
          @click="setFilter({ field: 'product_brand', value: 'Mitrex' })"
          :class="{ 'is-active': filters.product_brand == 'Mitrex' }">
          <a>Mitrex</a>
        </li>
        <li 
          @click="setFilter({ field: 'product_brand', value: 'Cladify' })"
          :class="{ 'is-active': filters.product_brand == 'Cladify' }">
          <a>Cladify</a>
        </li>
      </ul>
    </div>

    <v-fade-transition mode="out-in">
      <v-progress
        v-if="loading"
        :value="true">
      </v-progress>

      <div class="mt-3" v-else>
        <article 
          v-if="!loading && estimations.length == 0" 
          class="message is-info is-fullwidth">
          <div class="message-body">
            There are no Estimations.
          </div>
        </article>

        <div v-if="estimations.length > 0">

          <table 
            class="table is-hoverable is-clickable is-fullwidth 
              has-small-font sticky-header">
            <thead>
              <tr>
                <th>
                  <v-checkbox 
                    :value="allSelected" 
                    @input="toggleAllSelected($event)"/>
                </th>
                <th 
                  v-for="(header, headerIndex) in headers" 
                  :key="headerIndex">
                  {{ header.label }}
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr 
                class="v-centered"
                v-for="estimation in estimations"
                :key="estimation.id"
                @click="viewEstimation(estimation)">
                <td>
                  <v-checkbox 
                    @click.native.stop=""
                    :value="selected.includes(estimation.id)" 
                    @input="toggleSelected(estimation.id)"/>
                </td>
                <td>
                  {{ estimation.rfq ? estimation.rfq.project.project_name : '' }}
                </td>
                <td @click.stop="">
                  <router-link
                    @click.prevent=""
                    v-if="estimation.rfq" 
                    :to="{ 
                      name: 'RfqViewer', 
                      params: { 
                        rfqId: estimation.rfq.id,
                        productBrand: filters.product_brand
                      }
                    }">
                    {{ estimation.rfq.rfq_name }}
                  </router-link>
                </td>
                <td :class="{ 'has-text-grey-lighter': estimation.total_area_sqft == 0 }">
                  {{ estimation.total_area_sqft | commasep(0) }}
                </td>
                <td :class="{ 'has-text-grey-lighter': estimation.total_price_bef_adj == 0 }">
                  {{ estimation.total_price_bef_adj | currency }}
                </td>
                <td :class="{ 'has-text-grey-lighter': estimation.total_price_pre_tax == 0 }">
                  {{ estimation.total_price_pre_tax | currency }}
                </td>
                <td class="is-capitalized">
                  {{ estimation.status.toLowerCase() }}
                </td>
                <td>
                  <span class="is-size-7">
                    {{ formatDate(parseDate(estimation.created_on)) }}
                  </span>
                </td>
                <td>
                  {{ estimation.created_user.display_name }}
                </td>
                <td>
                  <div class="buttons buttons-right">
                    <button
                      @click.stop="launchConfirmDelete(estimation.id)" 
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-trash has-text-grey"></i>
                      </span>
                      <span>Delete</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>

          <!-- <div class="column">
            <table 
              class="table is-hoverable is-clickable is-fullwidth has-small-font">
              <thead>
                <tr>
                  <th>
                    <v-checkbox 
                      :value="allSelected" 
                      @input="toggleAllSelected($event)"/>
                  </th>
                  <th 
                    v-for="(header, headerIndex) in headers" 
                    :key="headerIndex">
                    {{ header.label }}
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr 
                  class="v-centered"
                  v-for="estimation in estimations"
                  :key="estimation.id"
                  @click="viewEstimation(estimation)">
                  <td>
                    <v-checkbox 
                      @click.native.stop=""
                      :value="selected.includes(estimation.id)" 
                      @input="toggleSelected(estimation.id)"/>
                  </td>
                  <td>
                    {{ estimation.rfq ? estimation.rfq.project.project_name : '' }}
                  </td>
                  <td>
                    <a 
                      v-if="estimation.rfq" 
                      :href="estimation.rfq.attachment" 
                      target="_blank">
                      {{ estimation.rfq.rfq_name }}
                    </a>
                  </td>
                  <td :class="{ 'has-text-grey-lighter': totSqft(estimation) == 0 }">
                    {{ totSqft(estimation) | commasep(0) }}
                  </td>
                  <td :class="{ 'has-text-grey-lighter': totValue(estimation) == 0 }">
                    {{ totValue(estimation) | currency }}
                  </td>
                  <td :class="{ 'has-text-grey-lighter': totPrice(estimation) == 0 }">
                    {{ totPrice(estimation) | currency }}
                  </td>
                  <td>
                    {{ estimationStatus(estimation) }}
                  </td>
                  <td>
                    <span class="is-size-7">
                      {{ formatDate(parseDate(estimation.created_on)) }}
                    </span>
                  </td>
                  <td>
                    {{ estimation.created_user.display_name }}
                  </td>
                  <td>
                    <div class="buttons buttons-right">
                      <button
                        @click.stop="launchConfirmDelete(estimation.id)" 
                        class="button is-small">
                        <span class="icon">
                          <i class="fas fa-trash has-text-grey"></i>
                        </span>
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div> -->
        </div>

      </div>
    </v-fade-transition>
    
    <v-pagination 
      class="mt-3"
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/> 

    <!-- <estimation-list-cladify 
      v-show="active == 'Cladify'"
      :project-id="cladifyProjectId"/> -->

  </div>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'
import VConfirmModal from '@/components/base/VConfirmModal'
import VPagination from '@/components/base/VPagination'
import VProgress from '@/components/base/VProgress'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'
// import EstimationListCladify from '@/components/estimations/EstimationListCladify'

import { parseJSON, format } from 'date-fns'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VConfirmModal, 
    VPagination, 
    VCheckbox, 
    VProgress,
    VFadeTransition,
    SearchAutocomplete
    // EstimationListCladify
  },
  data() {
    return {
      headers: [
        { label: 'Project' },
        { label: 'RFQ Name' },
        { label: 'Total SQFT' },
        { label: 'Total Value' },
        { label: 'Total Price' },
        { label: 'Status' },
        { label: 'Created On' },
        { label: 'Created By' }
      ],
      adding: false,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this estimation?',
        type: 'danger'
      },
      deleteConfirmedCb: null,
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => format(date, "yyyy-MM-dd HH:mm:ss")
    }
  },
  computed: {
    ...mapState("cladifyEstimations", [
      "estimations", "loading", "pagination", 
      "allSelected", "selected", "filters"
    ])
  },
  watch: {
    'pagination.page'() {
      let params = { ...this.filters, ...this.pagination }
      this.getEstimations(params);
    },
    filters: {
      handler(filters) {
        this.getEstimations(filters);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("cladifyEstimations", [
      "getEstimations", "deleteEstimation", "toggleAllSelected"
    ]),
    ...mapMutations("cladifyEstimations", [
      "changePage", "toggleSelected", "setFilter"
    ]),
    ...mapMutations("app", ["setNotification"]),
    initialize() {
      this.getEstimations(this.filters);
    },
    // totSqft(estimation) {
    //   if (estimation.estimation_details.length > 0) {
    //     return estimation.estimation_details.map(
    //       d => d.area_sqft
    //     ).reduce((a, b) => a + parseFloat(b) || 0, 0);
    //   } else {
    //     return 0
    //   }
    // },
    // totValue(estimation) {
    //   if (estimation.estimation_summary &&
    //     estimation.estimation_summary.summary.length > 0) {
    //     return estimation.estimation_summary.summary.map(
    //       d => d.what_should_be_paid
    //     ).reduce((a, b) => a + parseFloat(b) || 0, 0);
    //   } else {
    //     return 0
    //   }
    // },
    // totPrice(estimation) {
    //   if (estimation.estimation_summary &&
    //     estimation.estimation_summary.summary.length > 0) {
    //     return estimation.estimation_summary.summary.map(
    //       d => d.price
    //     ).reduce((a, b) => a + parseFloat(b) || 0, 0);
    //   } else {
    //     return 0
    //   }
    // },
    launchConfirmDelete(id) {
      if (!id) {
        this.deleteConfirmedCb = () => {
          this.selected.forEach(id => {
            this.deleteEstimation(id);
            this.confirmDelete.state = false;
          })
        }
        this.confirmDelete.message = `Are you sure you want to delete \
          the ${this.selected.length} selected estimations?`;
        this.confirmDelete.state = true;
      } else {
        this.deleteConfirmedCb = () => {
          this.deleteEstimation(id);
          this.confirmDelete.state = false;
        }
        this.confirmDelete.message = 'Are you sure you want to delete \
          this estimation?';
        this.confirmDelete.state = true; 
      }
    },
    viewEstimation(estimation) {
      this.$router.push({
        name: `EstimationViewer${estimation.rfq.product_brand}`, 
        params: {
          estimationId: estimation.id
        } 
      })
    },
    filterByProject(e) {
      this.setFilter({ field: 'project_id', value: e });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>